import { render, staticRenderFns } from "./ArticleModalEdit.vue?vue&type=template&id=8eb9db7e"
import script from "./ArticleModalEdit.vue?vue&type=script&lang=js"
export * from "./ArticleModalEdit.vue?vue&type=script&lang=js"
import style0 from "./ArticleModalEdit.vue?vue&type=style&index=0&id=8eb9db7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports